import React, { useCallback } from "react";

import { Box, makeStyles, Paper, Typography } from "@material-ui/core";

import ConnectSystemSubStep1 from "./SubStep1";
import ConnectSystemSubStep2 from "./SubStep2";

interface IProps {
  handleOpenConnectModal: () => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
    padding: theme.spacing(3, 5, 5, 3),
  },
  description: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  linkWithUnderline: {
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
  },
  instructionLink: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    width: "fit-content",
  },
}));

const FirstStepConnectSystemMessage: React.FC<IProps> = ({
  handleOpenConnectModal,
}) => {
  const classes = useStyles();

  const handleOpenConnectModalHandler = useCallback(() => {
    handleOpenConnectModal();
  }, []);

  return (
    <Paper elevation={3}>
      <Box className={classes.container}>
        <Typography variant="h6">
          ШАГ 2. Настройка iiko для&nbsp;работы с&nbsp;GuestMe
        </Typography>
        <Box className={classes.description}>
          <Typography variant="body1" color="textPrimary">
            Для начала работы с&nbsp;резервами, необходимо настроить главный
            терминал iiko в&nbsp;вашем ресторане и&nbsp;подключить его
            к&nbsp;Личному кабинету GuestMe.
          </Typography>
          {/* @todo: DEV-617 - мы сейчас обновляем портал документации, пока давай уберем ссылку, а как будет готов портал и новая инструкция - добавим, https://guestme.atlassian.net/browse/DEV-617?focusedCommentId=11894 */}
          {/* <Typography variant="body1" color="textPrimary">
            <a
              // @todo: DEV-617 - поправить ссылку на инструкцию
              href="https://guestme.ru/getting-started/new-rest/"
              target="_blank"
              className={`${classes.linkWithUnderline} ${classes.instructionLink}`}
              rel="noreferrer"
            >
              Подробная инструкция по&nbsp;настройке iiko
              <ArrowForward />
            </a>
          </Typography> */}
          <Typography variant="caption" color="textSecondary">
            Подключение к&nbsp;терминалу iiko необходимо для&nbsp;синхронизации
            информации о&nbsp;свободных столиках и&nbsp;передачи данных Гостя
            в&nbsp;ресторан (Имя, Телефон, ...). GuestMe не&nbsp;собирает
            финансовую и&nbsp;прочую информацию о&nbsp;Гостях,
            не&nbsp;являющихся пользователями сервиса. Информация необходима
            исключительно для&nbsp;корректной работы сервиса.
          </Typography>
        </Box>

        <ConnectSystemSubStep1 />

        <ConnectSystemSubStep2
          handleOpenConnectModal={handleOpenConnectModalHandler}
        />
      </Box>
    </Paper>
  );
};

export default FirstStepConnectSystemMessage;
